module.exports = __webpack_public_path__ + "img/times_card.77c0ffd7.png";